"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultHeaders = exports.DEFAULT_HEADER = exports.Header = void 0;
var Header;
(function (Header) {
    Header["APP"] = "x-lwtears-app";
    Header["USERNAME"] = "x-ssousername";
    Header["AUTH_TOKEN"] = "x-authtoken";
    Header["VERSION"] = "x-lwtears-app-version";
    Header["BUILD"] = "x-lwtears-app-build";
    Header["DEVICE"] = "x-lwtears-device";
    Header["TIMEZONE"] = "x-lwtears-timezone";
    Header["LOCALE"] = "x-lwtears-locale";
    Header["SESSION"] = "x-lwtears-session";
})(Header = exports.Header || (exports.Header = {}));
exports.DEFAULT_HEADER = 'value not found in lwt-common-frontend lib';
const getDefaultHeaders = (_a = {}) => {
    var { app, username, authToken } = _a, headers = __rest(_a, ["app", "username", "authToken"]);
    return (Object.assign({ [Header.APP]: app !== null && app !== void 0 ? app : process.env.REACT_APP_APP_NAME, [Header.USERNAME]: username !== null && username !== void 0 ? username : process.env.REACT_APP_USERNAME, [Header.AUTH_TOKEN]: authToken !== null && authToken !== void 0 ? authToken : process.env.REACT_APP_AUTHTOKEN, 'Content-Type': 'application/json' }, headers));
};
exports.getDefaultHeaders = getDefaultHeaders;
